import { FetchError, Modal } from "components/molecules";
import { Button, Typography } from "components/atoms";
import "./validate-mobile-modal.scss";
import classNames from "classnames";
import { useUpdateEventMutation } from "services/studyPlanner";
import { CloseIcon } from "components/atoms/Icon";

interface IProps {
  isOpen: boolean;
  handleOnclose: any;
  payload: any;
  theme: "light" | "dark";
  performUpdate: (eventId: any, newDate: any) => void;
  openBottom?: boolean;
  newDay: any;
  cardInfo: any;
}

export const ValidateMobileModal = ({
  isOpen,
  handleOnclose,
  payload,
  theme,
  openBottom,
  performUpdate,
  newDay,
  cardInfo,
}: IProps) => {
  const [_, { isLoading, isError }] = useUpdateEventMutation();

  const deriveStatus = (status: any) => {
    if (status === 500 || status === "Error") return "Error";
    else return "Warning";
  };

  const modifyMessage = (msg: any): string => {
    if (msg && typeof msg === "string") {
      if (msg.toLowerCase().indexOf("before") > 0) {
        const parts = msg.split("before");
        return `${parts[0]} <span class="custom-text">before</span> ${parts[1]}`;
      } else if (msg.toLowerCase().indexOf("after") > 0) {
        const parts = msg.split("after");
        return `${parts[0]} <span class="custom-text">after</span> ${parts[1]}`;
      } else {
        return msg;
      }
    }
    return "";
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnclose}
      theme={theme}
      style="validate-mobile-modal-custom-style"
      openBottom={openBottom}
    >
      {payload ? (
        <>
          <div
            className={classNames({
              "validate-mobile-modal-header-wrapper": true,
              "error-header":
                payload.Status === 500 || payload.Status === "Error",
              "warning-header": payload.Status === "Warning",
            })}
          >
            <Typography
              variant="h8Med"
              label={deriveStatus(payload.Status)}
              styles="validate-mobile-modal-header-text"
            />
            <div
              className="validate-mobile-modal-header-close-icon"
              onClick={handleOnclose}
            >
              <CloseIcon theme={theme} />
            </div>
          </div>
          <div
            className={classNames({
              "validate-mobile-modal-body-wrapper": true,
              "error-body":
                payload.Status === 500 || payload.Status === "Error",
              "warning-body": payload.Status === "Warning",
            })}
          >
            <Typography
              variant="h9Book"
              label={modifyMessage(payload.Message)}
              styles="validate-mobile-modal-info-text"
            />
            {isError ? (
              <FetchError content="Oops! failed to load resources" />
            ) : null}
            <div
              className={classNames({
                "validate-mobile-modal-button-wrapper": true,
                "warning-wrapper": payload.Status === "Warning",
              })}
            >
              {payload.Status === 500 || payload.Status === "Error" ? (
                <Button
                  icon={false}
                  type="score"
                  label="Okay"
                  onClick={handleOnclose}
                />
              ) : (
                <>
                  <Button
                    icon={false}
                    type="score"
                    label="Continue"
                    onClick={() =>
                      performUpdate(cardInfo.StudyPlannerEventId, newDay)
                    }
                    isLoading={isLoading}
                  />
                  <Button
                    icon={false}
                    type="online"
                    label="Cancel"
                    onClick={handleOnclose}
                  />
                </>
              )}
            </div>
          </div>
        </>
      ) : null}
    </Modal>
  );
};
